import type { BreakdownData } from 'lumen/routes/market/parity/insight';
import type { TrendsDataResponse } from 'lumen/routes/market/parity/insight/trends';
import { PI_BREAKDOWNS } from 'lumen/utils/constants/pi-constant-values';
import generateFakeName from 'lumen/utils/parity-analytics/pa-generate-fake-name';

const CONFIDENTIAL_BREAKDOWNS = [
  PI_BREAKDOWNS.MARKET_ID,
  PI_BREAKDOWNS.BRAND_ID,
  PI_BREAKDOWNS.SUBSCRIPTION_ID,
] as const;

export function demoTransformBreakdownData(data: BreakdownData): void {
  CONFIDENTIAL_BREAKDOWNS.forEach((segmentation) => {
    if (data[segmentation]) {
      data[segmentation].forEach((value) => {
        value.segmentation_value = generateFakeName(value, segmentation);
      });
    }
  });
}

export function demoTransformTrendsData(data: TrendsDataResponse): void {
  CONFIDENTIAL_BREAKDOWNS.forEach((breakdown) => {
    if (data[breakdown]) {
      Object.keys(data[breakdown]).forEach((extractDate) => {
        data[breakdown][extractDate]?.forEach((value) => {
          value.segmentation_value = generateFakeName(value, breakdown);
        });
      });
    }
  });
}
